export default class TargetNotSupportedError extends Error {
  static CODE = 'target-not-supported'

  constructor(methodName) {
    super(`method${methodName ? ` ${methodName}` : ''} not supported in target ${process.env.NODE_TARGET}`)
  }

  static raise(methodName) {
    throw new this(methodName)
  }
}
